import * as React from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { allDay, messages } from '../../messages';
/** @hidden */
export var DayViewAllDayRowContent = function (props) {
    var localization = useLocalization();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell k-scheduler-times-all-day" }, localization.toLanguageString(allDay, messages[allDay])),
        props.children));
};
//# sourceMappingURL=DayViewAllDayRowContent.js.map